import { secondary } from '../../../../../utils/brandColors';

export default () => ({
  heading: {
    fontSize: 30,
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: 24,
    color: secondary[500],
  },
  userTypeDescriptionGridItem: {
    maxWidth: 450,
    textAlign: 'center',
  },
  userDescription: {
    lineHeight: 1.25,
    marginTop: 16,
    display: 'inline-block',
  },
  userChip: {
    margin: '1rem',
    fontSize: '1rem',
    fontWeight: 500,
  },
});
